/**
 * Mocked transaction data for preview/mocked flows.
 * Used when the chatbot is in mocked mode to avoid API calls.
 */

import { TransactionStatus } from '@/common/config';
import type { TransStatement } from '@/common/api/model';

/**
 * Create mocked transaction data for preview flows
 */
export const createMockedTransactions = (): TransStatement[] => [
  {
    tradeId: 'MOCK-TXN-001',
    bizType: 1,
    tradeCode: 'DEP-2024-001',
    payChId: 1,
    payChTxId: 'CH-001',
    paySource: 1,
    status: TransactionStatus.Pending,
    currency: 'USD',
    amount: 150.0,
    amountSign: 1,
    initAmount: 150.0,
    feeType: 0,
    feeAmount: 0,
    afterBal: 350.0,
    createTime: Date.now() - 3600000, // 1 hour ago
    payFinishTime: 0,
    counterpart: 'Mobile Money',
    counterAuthority: '',
    counterFull: 'M-Pesa ***1234',
    goodsName: 'Deposit',
  },
  {
    tradeId: 'MOCK-TXN-002',
    bizType: 1,
    tradeCode: 'DEP-2024-002',
    payChId: 2,
    payChTxId: 'CH-002',
    paySource: 1,
    status: TransactionStatus.Successful,
    currency: 'USD',
    amount: 75.5,
    amountSign: 1,
    initAmount: 75.5,
    feeType: 0,
    feeAmount: 0,
    afterBal: 200.0,
    createTime: Date.now() - 86400000, // 1 day ago
    payFinishTime: Date.now() - 86300000,
    counterpart: 'Bank Transfer',
    counterAuthority: '',
    counterFull: 'Bank ***5678',
    goodsName: 'Deposit',
  },
];
